import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // initialise i18next BEFORE App mounts so first paint is localized
import App from "@/App";
import ErrorLogger from "@/utils/errorLogger";
import ScanTelemetry from "@/utils/scanTelemetry";

// Install global error handlers before React mounts so early errors are captured
ErrorLogger.install();
// Indestructible scan telemetry — listens for online/visibility/unload to
// drain the offline buffer and replays leftover events from previous sessions.
ScanTelemetry.install();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
